import { SvgIcon, SvgIconProps } from "@mui/material";

export const UserPlusIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.2"
        d="M17 18.667v-.625a3.542 3.542 0 0 0-3.542-3.542h-6.25a3.542 3.542 0 0 0-3.541 3.542v.625"
      />
      <circle
        cx="10.333"
        cy="7.833"
        r="3.333"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.2"
      />
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.2"
        d="M17.833 9.5v3.333M19.5 11.167h-3.333"
      />
    </svg>
  </SvgIcon>
);
